'use client';

import { use, useLayoutEffect } from 'react';

import type { UserData } from '@/lib/types';

import { useData } from '../context/data-context';
import RowReadOnly from './rows/row-read-only';

export default function FormImmutableData({ userData }: { userData?: Promise<UserData> }) {
  const resolvedUserData = userData === undefined ? null : use(userData);
  const { data, setData } = useData();

  useLayoutEffect(() => {
    if (resolvedUserData) {
      setData(resolvedUserData);
    }
  }, [resolvedUserData, setData]);

  const currentData = data ?? resolvedUserData;

  if (!currentData) {
    return null;
  }

  return (
    <div className="divide-y divide-gray-100">
      <RowReadOnly name="Name" value={currentData.immutableData.firstTenant.name} />
      {currentData.immutableData.secondTenant && (
        <RowReadOnly name="Zweiter Mieter" value={currentData.immutableData.secondTenant.name} />
      )}
      <RowReadOnly
        name="Adresse Ihrer neuen Wohnung"
        value={currentData.immutableData.apartment.address}
      />
      <RowReadOnly name="Mietkaution" value={currentData.immutableData.apartment.deposit_sum} />
      <RowReadOnly
        name="Beginn Mietvertrag"
        value={currentData.immutableData.apartment.rental_date}
      />
      <RowReadOnly name="Vermieter" value={currentData.immutableData.lessor.name} />
      <RowReadOnly name="Adresse des Vermieters" value={currentData.immutableData.lessor.address} />
    </div>
  );
}
